import type { TranslationSchema } from './types'

export const en: TranslationSchema = {
  Common: {
    reset: 'Reset',
    close: 'Close',
    back: 'Back'
  },
  Auth: {
    signUp: 'Sign up',
    activation: 'Activation',
    signIn: 'Sign in',
    authChallenge: 'MFA authentication',
    signOut: 'Sign Out',
    passwordReset: 'Password reset',
    passwordInitialize: 'Password Initialize',
    passwordUpdate: 'Password Update',
    userId: 'User ID',
    userName: 'Name',
    emailOrPhone: 'メールアドレスまたは携帯電話番号(SMS通知用)', // TODO: サブシス間で要調整（未翻訳項目）
    phoneNumber: '携帯電話番号(SMS通知用)', // TODO: サブシス間で要調整（未翻訳項目）
    email: 'E-mail',
    password: 'Password',
    reenterPassword: 'Re-enter password:',
    verificationCode: 'Verification code',
    sendVerificationCode: 'Send verification code',
    mfaCode: '検証コード', // TODO: サブシス間で要調整（未翻訳項目）
    sendMfaCode: '検証コード送信', // TODO: サブシス間で要調整（未翻訳項目）
    forgotPassword: 'Forgot password?',
    sendPasswordResetMail: 'Send Password Reset Mail',
    newPassword: 'New password',
    reenterNewPassword: 'Re-enter New Password:',
    updatePassword: 'Update Password',
    currentPassword: 'Current Password'
  }
}
